module.exports = __webpack_public_path__ + "img/OldRecords5.fcd943df.png";